import { fetcher } from "helpers/fetcher";

import {
  TGetStaffMaternityChldrenLeaveReq,
  TGetStaffMaternityChldrenLeaveRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeMaternityChldrenLeave = async (
  payload: TGetStaffMaternityChldrenLeaveReq
) => {
  return await fetcher<
    TGetStaffMaternityChldrenLeaveRes,
    TGetStaffMaternityChldrenLeaveReq["data"]
  >(ENDPOINT.USER.GET_EMPLOYEE_MATERNITY_CHILDREN_LEAVE, {
    params: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.USER.GET_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const queryGetEmployeeMaternityChldrenLeave = async (
  payload: TGetStaffMaternityChldrenLeaveReq
) => {
  return (await getEmployeeMaternityChldrenLeave(payload)).data;
};

queryGetEmployeeMaternityChldrenLeave._key = (
  payload: TGetStaffMaternityChldrenLeaveReq
) => [ENDPOINT.USER.GET_EMPLOYEE_MATERNITY_CHILDREN_LEAVE.url, payload];
